import {Translations} from '../config/translations';
import { DonationFrequencyType } from '../config/donation-frequency-type';

export class DonationProvider {
    intervals = [
        {
            label: Translations.INTERVAL_ONE_TIME,
            value: DonationFrequencyType.ONE_TIME
        },
        {
            label: Translations.INTERVAL_MONTHLY,
            value: DonationFrequencyType.MONTHLY
        }
    ];

    get subscriptionPlans() {
        return this.intervals;
    }

    setSubscriptionPlans(newInterval: any) {
        this.intervals.push(newInterval);
    }
}
